/**
 * Authentication types for QuickMask (Supabase)
 */

// Re-export Supabase types for convenience
export type { User, Session } from '@supabase/supabase-js';

export interface PasswordValidation {
    minLength: boolean;
    hasUppercase: boolean;
    hasLowercase: boolean;
    hasNumber: boolean;
    isValid: boolean;
}

export function validatePassword(password: string): PasswordValidation {
    const minLength = password.length >= 8;
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /\d/.test(password);

    return {
        minLength,
        hasUppercase,
        hasLowercase,
        hasNumber,
        isValid: minLength && hasUppercase && hasLowercase && hasNumber
    };
}
